import { IconDatabase } from '@tabler/icons-react';

import type { RegisterDatasetInput, RegisterDatasetOutput } from './schema.ts';
import { ToolCompleteBadges } from '#plugin-chat/components/tool-display/ToolCompleteBadges.tsx';
import { ToolDisplay } from '#plugin-chat/components/tool-display/ToolDisplay.tsx';
import { useToolPart } from '#plugin-chat/hooks/useToolPart.ts';
import type { ToolProgressComponent } from '#plugin-chat/lib/tool/progress-registry.ts';

/**
 * UI component for RegisterDatasetTool.
 */
export function RenderRegisterDatasetTool() {
  const toolPart = useToolPart<RegisterDatasetInput, RegisterDatasetOutput>();
  const rowCount = undefined;

  return (
    <ToolDisplay>
      <ToolDisplay.Running>Storing dataset...</ToolDisplay.Running>
      <ToolDisplay.Complete color="var(--mantine-color-cyan-4)" icon={IconDatabase}>
        <span>Dataset stored</span>
        <ToolCompleteBadges outputDataset={toolPart.args?.outputDataset} rowCount={rowCount} rowCountColor="cyan.4" />
      </ToolDisplay.Complete>
      <ToolDisplay.Error>Failed to register data set</ToolDisplay.Error>
    </ToolDisplay>
  );
}
/**
 * Progress component for RegisterDatasetTool.
 *
 * Rendered inside the "AiPSO Agent is ..." progress bubble while the tool is running.
 */
export const ProgressRegisterDatasetTool: ToolProgressComponent<RegisterDatasetInput, RegisterDatasetOutput> = () => (
  <>storing dataset...</>
);
